<script>
    export default {
        props: {
            // See https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver for details.
            childList: Boolean,
            attributes: Boolean,
            characterData: Boolean,
            subtree: Boolean,
            attributeOldValue: Boolean,
            characterDataOldValue: Boolean,
            attributeFilter: {type: Array, default: () => []},
        },

        data() {
            return {
                mutationObserver: null,
            };
        },

        computed: {
            observerSettings() {
                const settings = {
                    childList: this.childList,
                    attributes: this.attributes,
                    characterData: this.characterData,
                    subtree: this.subtree,
                    attributeOldValue: this.attributeOldValue,
                    characterDataOldValue: this.characterDataOldValue,
                };

                if (settings.attributes) {
                    settings.attributeFilter = this.attributeFilter;
                }

                return settings;
            },
        },

        mounted() {
            this.mutationObserver = new MutationObserver(this.handleSlotChange);
            this.mutationObserver.observe(this.$el, this.observerSettings);
            this.handleSlotChange();
        },

        render() {
            if (this.$slots.default.length !== 1) {
                throw new Error('SlotWatcher requires exactly one child');
            }

            return this.$slots.default[0];
        },

        methods: {
            handleSlotChange() {
                this.$emit('change');
            }
        },
    };
</script>
